import { DEFAULT_CSS_CLASS } from '@constants';
import './editor.scss';

const {
  blockEditor: { useBlockProps, useInnerBlocksProps, useSetting },
} = wp;

const BLOCKS_TEMPLATE = [
  ['core/paragraph', { placeholder: 'Accordion Top Content' }],
];

const Edit = ({ name }) => {
  const defaultCssClass = DEFAULT_CSS_CLASS.ACCORDION;

  const blockProps = useBlockProps({
    className: `${defaultCssClass}__top-content`,
  });

  const innerBlocksProps = useInnerBlocksProps(blockProps, {
    template:
      useSetting(`custom.blocks.${name}.blocksTemplate`) ?? BLOCKS_TEMPLATE,
    templateLock: false,
  });

  return <div {...innerBlocksProps} />;
};

export default Edit;
